import { AnimatePresence } from 'framer-motion';
import { useRef } from 'react';
import animations from '../../helpers/animations';
import { useAddressModalStore } from '../../store/address/addressModalStore';
import { AddressForm } from './pieces/AddressForm';
import {
    BackgroundModal,
    CloseModalButton,
    ModalContent,
    ModalTitle,
    ModalWrapper,
} from './styles';

export function ModalAddress() {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const addressModal = useAddressModalStore();

    function handleCloseModal() {
        addressModal.update({
            isVisible: false,
        });
    }

    return (
        <AnimatePresence>
            {addressModal.isVisible && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={handleCloseModal}
                    {...animations.fadeInOut(0.1)}
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <>
                            <ModalTitle>
                                <p>{addressModal.address.foreigner ? 'Billing Address' : 'Local de faturamento'}</p>
                            </ModalTitle>
                            <CloseModalButton onClick={handleCloseModal} />
                            <ModalContent>
                                <AddressForm closeModal={handleCloseModal} />
                            </ModalContent>
                        </>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>
    );
}
